import React from 'react';

import { Form } from '@dashboard/components/Formik';
import useProduct from '../useProduct';

const ProductInventoryForm = () => {
  const { product, updateProduct } = useProduct();

  return (
    <Form
      initialValues={{
        sku: product.sku,
        stock: product.stock,
        hasUnlimitedStock: product.hasUnlimitedStock,
      }}
      onSubmit={async (values, actions) => {
        const { data, error } = await updateProduct.mutateAsync(values);

        actions.resetForm({
          values: {
            sku: data.sku,
            stock: data.stock,
            hasUnlimitedStock: data.hasUnlimitedStock,
          },
        });

        return {
          data,
          error,
        };
      }}
      fields={({ values }) => [
        {
          name: 'sku',
          label: 'SKU',
          type: 'text',
          placeholder: '1004',
        },
        {
          name: 'hasUnlimitedStock',
          label: 'Unlimited stock',
          type: 'toggle',
        },
        ...(values.hasUnlimitedStock
          ? []
          : [
              {
                name: 'stock',
                label: 'Stock',
                type: 'text',
                placeholder: '0',
              },
            ]),
      ]}
    />
  );
};

export default ProductInventoryForm;
